import { searchInCollection } from "../typesenseFetchClient.js";

export default async function fetchProductReviews(
  productId,
  page = 1,
  pageSize = 10,
  sortBy = "reviewRating",
  sortDirection = "desc"
) {
  try {
    const searchParameters = {
      max_facet_values: 1000,
      q: "*",
      query_by: "productName",
      filter_by: `productId:=${productId}`,
      sort_by: `${sortBy}:${sortDirection}`,
      page,
      per_page: pageSize,
    };

    const data = await searchInCollection("stamped_reviews", searchParameters);
    const documents = data.hits.map(hit => hit.document);
    return {
      page,
      totalPage: Math.ceil(data.found / pageSize),
      data: documents,
    };
  } catch (error) {
    console.error("Error of fetchProductReviews:", error);
    return null;
  }
}
